export enum OperationStatus {
    None = 0,
    Queued = 1,
    Pending = 2,
    Done = 3,
    Failed = 4,
}
